import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { FiberManualRecord, RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import FilterSelect from "../../../../components/select/filterSelect";
import { Button, MenuItem, Typography } from "@mui/material";
import { routeName } from "../../../../routes/routeName";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { degreeApi } from "../../../../api/degree/degree.api";
import { advisorEstimateScoreApi } from "../../../../api/advisor-estimate-score/advisor-estimate.api";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import { colors } from "../../../../constants/colors";
import { icons } from "../../../../assets/icons/icons";
import { ReportApi } from "../../../../api/report/Report.api";
import { saveAs } from "file-saver";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import { getFileExtension } from "../../../../utils/fileTypeDownload";
import { dateToView } from "../../../../utils/date.utils";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { getEnumValue } from "../../../../utils/common";
import { ADVISOR_ESTIMATE } from "../../../../domains/enum/estimate";

type Props = {};

const TeacherEvaluationScoresEmployeeDetail: React.FC<Props> = (
  props: Props
) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id, id_employee } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_year = queryParams.get("year");
  const prop_term = queryParams.get("term");
  const prop_employee_name = queryParams.get("employee_name");
  const prop_employee_no = queryParams.get("employee_no");

  const [data, setData] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getData = async (id: number, id_employee: number) => {
    try {
      if (!id_employee || !id) {
        return;
      }

      let query: any = {
        page: page,
        limit: pageLimit,
        sortBy: sortBy,
        sortType: sortType,
        keyword: search ?? "",
      };

      const res =
        await advisorEstimateScoreApi.getCourseAnnualEmployeeByIdCourseOfStudyAndIdEmployee(
          +id,
          +id_employee,
          query
        );
      const data = res.data;
      if (data.status < 300) {
        setData(res.data?.data?.items ?? []);
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
      } else {
        setData([]);
      }
    } catch (error) { }
  };

  const headCells = [
    {
      id: "course_name",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อรายวิชา",
    },
    {
      id: "course_no",
      width: 125,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "รหัสวิชา",
    },
    {
      id: "year",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชั้นปีที่สอน",
    },
    // {
    //   id: "teacher",
    //   width: 100,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "อาจารย์ผู้สอน",
    // },
    {
      id: "score",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "คะแนนเฉลี่ย",
    },
    {
      id: "start_date",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "วันที่เริ่มต้นเปิดให้ประเมิน",
    },
    {
      id: "end_date",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "วันที่สิ้นสุดเปิดให้ประเมิน",
    },
    {
      id: "status",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "สถานะ",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  // study_day 0 === อาทิด
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_courses,
      courses_name,
      courses_no,
      academic_year,
      id_employee,
      full_name,
      buddhist_name,
      employee_no,
      points,
      id_course_annual,
      id_course_annual_employee,
      estimate_start_date,
      estimate_end_date,
      estimate_status
    } = objData;

    const objRenderData = {
      key: id_course_annual_employee,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: courses_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: courses_no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: academic_year ?? "-",
        },
        // {
        //   option: "TEXT",
        //   align: "start",
        //   label: full_name ?? "-",
        // },
        {
          option: "TEXT",
          align: "center",
          label: parseFloat(points).toFixed(1) ?? "0",
        },
        {
          option: "TEXT",
          align: "start",
          label: estimate_start_date
            ? dateToView(estimate_start_date)
            : estimate_start_date,
        },
        {
          option: "TEXT",
          align: "start",
          label: estimate_end_date
            ? dateToView(estimate_end_date)
            : estimate_end_date,
        },
        {
          option: "COMPONENT",
          align: "start",
          component: (
            <CustomStatus
              label={
                getEnumValue(ADVISOR_ESTIMATE, estimate_status) ||
                "Unknown status"
              }
              type="outlined"
              color={
                estimate_status === ADVISOR_ESTIMATE.OPEN_FOR_ESTIMATE ||
                  estimate_status === ADVISOR_ESTIMATE.START_FOR_ESTIMATE
                  ? "success"
                  : estimate_status === ADVISOR_ESTIMATE.NOT_START_YET
                    ? "warning"
                    : "error"
              }
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  navigate(
                    routeName.advisor.TeacherEvaluationScores +
                    `/${id_course_annual}/course-annual-student-estimate?employee_no=${employee_no}&employee_name=${full_name}&year=${prop_year}&term=${prop_term}&id_employee=${id_employee}&id_course_of_study=${id}&course=${`รหัสวิชา : ${courses_no} / ชื่อรายวิชา : ${courses_name}&id_course_annual=${id_course_annual}`}`
                  );
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    if (id && id_employee) {
      getData(+id, +id_employee);
    }
  }, [page, pageLimit, sortBy, sortType, search, id, id_employee]);

  const handleDownloadFile = async (
    id_course_study: number,
    id_employee: number,
  ) => {
    let query: any = {
      type: "xlsx",
    };

    dispatch(setLoading());
    await ReportApi.downloadEstimateCourseByIdCourseStudyAndIdEmployee(
      id_course_study,
      id_employee,
      query
    )
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          const contentType = res.headers["content-type"];

          const blob = new Blob([response], { type: contentType });

          const fileExtension = getFileExtension(contentType || "");

          const fileName = `${new Date().getTime()}.${fileExtension}`;

          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  return (
    <div>
      <NavigateListCustom
        navigateData={[
          {
            name: `คะแนนประเมินอาจารย์ผู้สอน`,
            key: "1",
            pathName: routeName.advisor.TeacherEvaluationScores,
            onClick: () =>
              navigate(`${routeName.advisor.TeacherEvaluationScores}`),
          },
          {
            name: `คะแนนประเมินอาจารย์ผู้สอน ปีการศึกษา ${prop_year} ภาคเรียนที่ ${prop_term}`,
            key: "2",
            pathName: routeName.advisor.TeacherEvaluationScores,
            onClick: () =>
              navigate(
                `${routeName.advisor.TeacherEvaluationScores}/${id}/detail?year=${prop_year}&term=${prop_term}`
              ),
          },
          {
            name: `${prop_employee_name} ${prop_employee_no}`,
            key: "3",
            pathName: "",
            onClick: () =>
              navigate(
                routeName.advisor.TeacherEvaluationScores +
                `/${id}/course-detail/${id_employee}/employee?employee_no=${prop_employee_no}&employee_name=${prop_employee_name}&year=${prop_year}&term=${prop_term}`
              ),
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{`${prop_employee_name} ${prop_employee_no}`}</Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อวิชา/รหัสวิชา"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-9 flex justify-end">
          <Button
            variant="outlined"
            sx={{
              backgroundColor: colors.success3,
              color: "white",
              border: colors.success3,
              "&:hover": {
                backgroundColor: colors.success3, // Retain the same background color
                borderColor: colors.success3, // Retain the same border color
              },
            }}
            startIcon={<img src={icons.icon_excel} alt="start-icon" />}
            onClick={() => {
              if (id && id_employee) {
                handleDownloadFile(+id, +id_employee);
              }
            }}
          >
            ดาวน์โหลด Excel
          </Button>
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1940}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <ButtonOutlined
          onClick={() => navigate(-1)}
          mode="del"
          buttonName="ย้อนกลับ"
        />
      </div>
    </div>
  );
};

export default TeacherEvaluationScoresEmployeeDetail;
